import { render, staticRenderFns } from "./SupplierToolingDetailMaintain.vue?vue&type=template&id=20591874&scoped=true"
import script from "./SupplierToolingDetailMaintain.vue?vue&type=script&lang=js"
export * from "./SupplierToolingDetailMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20591874",
  null
  
)

export default component.exports